import { CustomDate } from "@/types/schemas/person";

export const isDateInPast = (value: CustomDate): boolean => {
  const currentDate = new Date();
  if (!value) {
    return false;
  }

  return value < currentDate;
};

export const nextYear = new Date().getFullYear() + 1;
